module.exports = __webpack_public_path__ + "img/geod_5.7d596463.jpg";